import { NgModule } from "@angular/core";

import { FilterPipe } from "@core/pipes/filter.pipe";
import { OrderByPipe } from "./orderBy.pipe";

import { InitialsPipe } from "@core/pipes/initials.pipe";

import { SafePipe } from "@core/pipes/safe.pipe";
import { StripHtmlPipe } from "@core/pipes/stripHtml.pipe";

@NgModule({
  declarations: [
    InitialsPipe,
    FilterPipe,
    StripHtmlPipe,
    SafePipe,
    OrderByPipe,
  ],
  imports: [],
  exports: [InitialsPipe, FilterPipe, StripHtmlPipe, SafePipe, OrderByPipe],
})
export class CorePipesModule {}
